<finra-mu1-header
  *ngIf="!isRegulatorUser && !hasRoutingError"
  class="mu1-header"
  aria-label="header"
  role="banner"
  [userName]="loggedInUserName"
  [subjectId]="subjectId"
  [isFormView]="formView"
  [class.standalone]="isStandalone"
></finra-mu1-header>
<div *ngIf="!showSubmissionConfirmation">
  <finra-page-level-nav
    [data]="navData$ | async"
    [isCollapsible]="false"
    id="app-mu1-form-navigator"
    [width]="
      (loading$ | async) ||
      (isMobileView && !isRegulatorUser && !hasRoutingError ? '150px' : '') ||
      (isPrintMode ? '0px' : '') ||
      (isRegulatorUser ? '0px' : '') ||
      (hasRoutingError ? '0px' : '')
    "
    (navSelected)="navigateToMenu($any($event).detail)"
    aria-label="navigation"
    role="navigation"
  >
    <div class="form-content" [ngClass]="isGuidance || isRegulatorUser || hasRoutingError ? 'content-full-view' : ''">
      <ng-container *ngIf="loading$ | async; else form">
        <div class="center-page">
          <finra-spinner [loadingText]="loadingText" [isBackdrop]="false"></finra-spinner>
        </div>
      </ng-container>

      <ng-template #form>
        <router-outlet> </router-outlet>
      </ng-template>
    </div>
  </finra-page-level-nav>

  <app-footer
    *ngIf="!(loading$ | async) && !hasRoutingError && (!isRegulatorUser || viewType === 'formView')"
    [ngStyle]="{ display: isPrintMode ? 'none' : null }"
    [class.standalone]="isStandalone"
    (save)="onSave($event)"
    (submit)="onSubmit()"
    (updateOptions)="updateFooterOptions($event)"
    (validate)="onValidate()"
    (back)="onBack()"
    (next)="onNext()"
    (print)="onPrint()"
    (redline)="onToggleRedline($event)"
    [saveInProgress]="saveInProgress"
    [reviewed]="formReviewed"
    [viewType]="viewType"
    [section]="currentNavId"
    [sectionNavData]="navrouteData"
    [lastOpenedSectionDE]="lastOpenedSectionDE"
    aria-label="footer"
    role="contentinfo"
  >
  </app-footer>

  <rampdi-completeness-check
    [data]="completenessCheck$ | async"
    (onclick)="navigateToField($event)"
    (close)="closeWidget()"
    (refresh)="onValidate()"
  >
  </rampdi-completeness-check>
  <rampdi-redline-widget
    *ngIf="viewType === 'formView'"
    [data]="redlineDiff$ | async"
    (onclick)="navigateToField($event)"
    (close)="closeWidget('redline')"
  ></rampdi-redline-widget>
</div>

<finra-modal theme="warning" size="md" *ngIf="concurrencyModal && !migrationModal" back-drop="true">
  <div slot="title">MU1 Refresh</div>
  <div class="context">
    <p>
      Updates to your MU1 have been submitted since creating this draft. Click continue to proceed to your updated MU1.
    </p>
    <ul>
      <li style="margin-bottom: 10px">
        To view and/or print the comparison of changes made between the previous draft and submitted MU1. click
        <a
          (click)="navigateTo()"
          (keydown.enter)="navigateTo()"
          (keydown.space)="navigateTo()"
          tabindex="0"
          role="link"
          aria-label="View and print the comparison of changes made between the previous draft and submitted MU1"
          >here</a
        >.
      </li>
      <li>
        To view and/or print the previous draft MU1. click
        <a
          [routerLink]="[environment.dxtBasePath + '/forms/mu1/view/formView/section/all']"
          [queryParamsHandling]="'preserve'"
          target="_blank"
          aria-label="View and print the previous draft MU1"
          >here</a
        >.
      </li>
    </ul>
  </div>
  <finra-button slot="commands" (click)="onContinue()">CONTINUE</finra-button>
</finra-modal>

<finra-modal theme="warning" size="md" *ngIf="migrationModal" back-drop="true">
  <div slot="title">Form Update Required</div>
  <div class="form-update">
    <p style="margin-bottom: 25px">
      The MU1 Form has been updated to reflect revised disclosure questions and employment reporting. To learn what has
      changed with this update, refer to the
      <a
        [href]="
          environment.urls.mortgageLicensingSystem + '/knowledge/Products/nmls/aboutNMLS/SitePages/ReleaseNotes.aspx'
        "
        tabindex="0"
        role="link"
        target="_blank"
        aria-label="View NMLS Resource Center"
        >NMLS Resource Center</a
      >.
    </p>
    <p>
      To view form in the previous draft version before continuing select
      <a
        [routerLink]="['/view/dataEntry/section/disclosureQuestions']"
        [queryParams]="{ instanceId: migrationInstanceId }"
        target="_blank"
        aria-label="View the previous draft MU1"
        >previous draft version</a
      >.
    </p>
  </div>
  <finra-button slot="commands" (click)="onMigrationContinue()">CONTINUE</finra-button>
</finra-modal>
